function Loading() {
    return <div className="no-results-container">
        <div className="no-results">
            <div className="no-results-icon">
                <i className="fa-2x fa-solid fa-face-confused"></i>
            </div>
            <div className="no-results-text-container">
                <h3>
                    Sorry
                </h3>
                <div>
                    We could not find anything matching that search
                </div>
            </div>
        </div>
    </div>
}

export default Loading;